import React from 'react';
import styled from 'styled-components';

import Icon from '../Icon';
import Button from '../Button';

function Delete(props) {
  return (
    <StyledButton blank {...props}>
      <Icon name="trash-2" />
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  padding: 4px;
`;

export default Delete;
